<!--家电共同被保险人-->
<template>
	<div>
		<el-card>
			<template v-slot:header>
				<div class="u-flex u-row-between u-col-center" style="height: 42px">
					<span class="u-font-weight-bold u-font-18">共同被保险人</span>
					<el-tooltip effect="light" placement="top">
						<template #content>
							<div style="white-space: pre-line">
								同一人通过亲属实际控制多个网点、网点间 代结、上下级网点关系，如有上述共同被保 险企业应在投保时列明
							</div>
						</template>
						<el-button v-if="isShowAddBtn" icon="el-icon-plus" type="primary" @click="onAddUnits">
							增加共同被保险人
						</el-button>
					</el-tooltip>
				</div>
			</template>
			<div v-if="!isShowAddBtn">
				<el-empty
					:image-size="80"
					class="u-font-18 u-font-weight-bold"
					description="确认投保企业后，才能新增公共被保险人！"></el-empty>
			</div>
			<avue-crud v-else ref="refInsured" :data="insuredData" :option="optionInsured" @row-del="onRowDel"></avue-crud>
		</el-card>
		<el-dialog :visible.sync="isShowAddDialog">
			<FormUnitNew
				ref="refUnit"
				:applicantFormData="applicantFormData"
				:from-type="4"
				:insure-type="insureType"
				:productId="productId"
				:sourceProductId="sourceProductId"
				class="u-m-b-20"
				@onSubmittedData="onSubmittedDataM"></FormUnitNew>
		</el-dialog>
	</div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件等等）
// import { mapGetters } from 'vuex'

import {option_insured_form_new} from '@/const/crud/insurance/policy'
import FormUnitNew from '@/views/insuranceCenter/components/formUnitNew.vue'
import {getInsureUnitData, getProductCenterUnitData} from 'meibao-insure/src/util/unitFormUtils'

export default {
	name: 'formUnitInsuredNew',
	mixins: [],
	components: {FormUnitNew},
	props: {
		insureType: String | Number,
		productId: String | Number,
		sourceProductId: String | Number,
		holderCode: String,
		applicantFormData: {
			type: Object,
			required: true,
			default: () => {
				return {}
			},
		},
	},
	data() {
		return {
			optionInsured: this.deepClone(option_insured_form_new),
			currentUnitData: {},
			insuredData: [],
			isSubmitCar: false,
			isShowAddDialog: false,
			isShowAddBtn: false,
		}
	},
	computed: {
		// ...mapGetters(['userPermissions','buttonType'])
		//获取最多可以设置多少共同被保险人
		getMaxInsuredNum() {
			if (this.validatenull(this.applicantFormData)) {
				return 3
			}
			let {maxCommonInsurantCount = 3} = this.applicantFormData.config
			return maxCommonInsurantCount
		},
	},
	watch: {
		applicantFormData: {
			handler(newVal = null, oldVal) {
				if (newVal) {
					console.log('applicantFormData-------', newVal)
				}
			},
			immediate: true,
		},
	},
	mounted() {
		this.$Bus.$on('taxTypeNew', this.onDealTaxType)
	},
	activated() {
		this.$Bus.$on('taxTypeNew', this.onDealTaxType)
	},
	deactivated() {
		this.$Bus.$off('taxTypeNew')
	},
	methods: {
		//设置数据
		onSetGongBaoData(tempInsuredData) {
			this.insuredData = tempInsuredData.map((itemData) => {
				return getProductCenterUnitData(itemData)
			})
		},
		onAddUnits() {
			let maxNum = this.getMaxInsuredNum
			if (maxNum === 0) {
				this.$alert('获取共同被保险人数据不正确，请手动刷新浏览器！', '提示').then(() => {})
				return
			}
			if (this.insuredData.length >= maxNum) {
				this.$alert(`最多只能增加${maxNum}个共同被保险人！`, '提示').then(() => {})
				return
			}
			this.isShowAddDialog = true
		},
		onRowDel(row, index) {
			this.insuredData.splice(index, 1)
			//重新获取报价
		},
		//获取数据,报价接口专用
		onGetInsuredDataCalc() {
			return this.insuredData
		},
		//获取数据,Insure接口专用
		onGetSubGongBaoData() {
			return (
				this.insuredData.map((itemData) => {
					return getInsureUnitData(itemData)
				}) || []
			)
		},
		onSubmittedDataM(uniFormData) {
			console.log('onSubmittedDataM-------', uniFormData)
			let {name = '', certNo = ''} = uniFormData
			let {name: currentName = '', certNo: currentCertNo = ''} = this.currentUnitData
			if (name === currentName || certNo === currentCertNo) {
				this.$alert(`企业名称：${name}，或企业信用代码：${certNo}和投保企业相同，请修改共同被保险人`).then(() => {})
				return
			}
			//在已添加的共同被保险人列表中查找是否已存在该企业
			let tempIndex = this.insuredData.findIndex(
				({name: name1, certNo: certNo1}) => name === name1 || certNo === certNo1,
			)
			if (tempIndex !== -1) {
				this.$alert(`企业名称：${name}，或企业信用代码：${certNo}已存在，请修改共同被保险人`).then(() => {})
				return
			}
			//添加
			this.insuredData.push(uniFormData)
			//重新获取报价

			this.isShowAddDialog = false
			//清空
			this.$refs.refUnit.onRecycleData()
		},
		onDealTaxType(unitFormData) {
			this.isShowAddBtn = !this.validatenull(unitFormData)
			if (!this.isShowAddBtn) {
				return
			}
			//确认企业信息！！
			this.currentUnitData = unitFormData
			let {name: name1 = '', certNo: certNo1 = ''} = unitFormData
			//需要过滤共同被保险人，判断是否和投保企业相同
			if (this.insuredData.length > 0) {
				this.insuredData = this.insuredData.filter(({name = '', certNo = ''}) => name !== name1 && certNo !== certNo1)
			}
		},
	},
	beforeDestroy() {},
	destroyed() {},
	beforeRouteEnter(to, from, next) {
		next()
	},
	beforeRouteUpdate(to, from, next) {
		next()
	},
	beforeRouteLeave(to, from, next) {
		next()
	},
}
</script>

<style lang="scss" scoped>
::v-deep .el-card__header {
	padding: 10px 20px;
}

::v-deep .el-button--mini {
	padding: 0 5px;
}

::v-deep .el-button {
	height: 28px;
}

::v-deep .avue-crud__menu {
	justify-content: center;
	align-items: center;

	.el-button--text {
		color: red !important;
	}
}
</style>
